import { CopyOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { useCrudRecord } from '../../../containers/crud/recordContext';
import { ModalTrigger } from '@arivaa-react/components/modal';
import { ApiForm } from '../../../containers/apiForm';
import { url } from '../../../constants/api';

export function DuplicateWebsite({ users = [], isAdmin }) {
  const record = useCrudRecord();

  return (
    <ModalTrigger
      modalProps={{
        title: 'Copy Website',
        footer: null,
      }}
      content={
        <ApiForm
          apiUrl={url(`websites/duplicate-website/${record.key}`)}
          method="POST"
          elements={[
            {
              type: 'text',
              label: 'Website Name',
              name: 'name',
              required: true,
            },
            isAdmin && {
              type: 'select',
              label: 'User',
              name: 'userId',
              inputProps: {
                options: (users || []).map((user) => ({
                  value: user.key,
                  label: user.displayName,
                })),
                showSearch: true,
                optionFilterProp: 'label',
              },
              required: true,
            },
          ].filter(Boolean)}
        />
      }
    >
      <Tooltip title="Duplicate Website">
        <Button className="btn blue-btn-text">
          <CopyOutlined />
        </Button>
      </Tooltip>
    </ModalTrigger>
  );
}
